import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CheckCircleIcon, AlertTriangleIcon, InfoIcon, ChevronDownIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
export function EFootPage() {
  const [showLegacy, setShowLegacy] = useState(false);
  return <div className="min-h-screen bg-gray-50 flex flex-col font-sans text-gray-900" data-id="element-393">
      <Header data-id="element-394" />

      <main className="flex-grow pt-32 pb-20" data-id="element-395">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-396">
          {/* Hero Section */}
          <div className="text-center mb-16" data-id="element-397">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-100 text-blue-800 text-sm font-bold uppercase tracking-wider mb-6" data-id="element-398">
              <InfoIcon className="w-4 h-4" data-id="element-399" />
              Buyer's Guide
            </div>
            <h1 className="text-4xl md:text-5xl font-black uppercase tracking-tight mb-6" data-id="element-400">
              E-Footgear <span className="text-blue-600" data-id="element-401">Usage Guide</span>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-402">
              Daedo electronic footgear has evolved. Ensure you have the right
              equipment for your scoring system by understanding the differences
              between the current{' '}
              <strong className="text-gray-900" data-id="element-403">Gen 3</strong> and{' '}
              <strong className="text-gray-900" data-id="element-404">Gen 2</strong> generations.
            </p>
          </div>

          {/* Current Lineup Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-405">
            {/* Gen 3 Card */}
            <div className="bg-white rounded-2xl shadow-lg border-2 border-blue-500 overflow-hidden relative flex flex-col" data-id="element-406">
              <div className="absolute top-0 right-0 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-bl-lg uppercase tracking-wider z-10" data-id="element-407">
                Newest Generation
              </div>
              <div className="p-8 bg-gradient-to-b from-blue-50 to-white flex-grow" data-id="element-408">
                <div className="w-full aspect-square mb-6 bg-white rounded-xl p-4 shadow-sm flex items-center justify-center" data-id="element-409">
                  <img src="https://cdn.magicpatterns.com/uploads/cViGkDXcDmPVipYt9uyQmt/Gen3_E-Foot_Gear.jpg" alt="Gen3 E-Foot Gear" className="max-w-full max-h-full object-contain" data-id="element-410" />
                </div>
                <h2 className="text-2xl font-black text-gray-900 mb-3" data-id="element-411">
                  Gen 3 WT Taekwondo Sensor Sock
                </h2>
                <p className="text-gray-600 mb-6" data-id="element-412">
                  The latest evolution in electronic scoring, featuring
                  redesigned sensor placement for unmatched precision and a
                  better fit.
                </p>
                <div className="space-y-3" data-id="element-413">
                  <div className="flex items-start gap-3" data-id="element-414">
                    <CheckCircleIcon className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-415" />
                    <span className="text-sm font-medium text-gray-800" data-id="element-416">
                      Designed specifically for the Gen 3 electronic scoring
                      ecosystem
                    </span>
                  </div>
                  <div className="flex items-start gap-3 bg-red-50 p-3 rounded-lg border border-red-100" data-id="element-417">
                    <AlertTriangleIcon className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-418" />
                    <span className="text-sm font-bold text-red-900" data-id="element-419">
                      MUST be used with Gen 3 Electronic Protector (E-Hogu) ONLY
                    </span>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-gray-50 border-t border-gray-100 mt-auto" data-id="element-420">
                <a href="#gen3" className="block w-full text-center bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-lg transition-colors" data-id="element-421">
                  Shop Gen 3 Footgear
                </a>
              </div>
            </div>

            {/* Gen 2 Card */}
            <div className="bg-white rounded-2xl shadow-md border border-gray-200 overflow-hidden flex flex-col" data-id="element-422">
              <div className="p-8 flex-grow" data-id="element-423">
                <div className="w-full aspect-square mb-6 bg-gray-50 rounded-xl p-4 flex items-center justify-center" data-id="element-424">
                  <img src="https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FDaedo%2FGeneration2%2Fepro29037_1_optimizacionweb.jpg" alt="Gen2 E-Foot Gear" className="max-w-full max-h-full object-contain" data-id="element-425" />
                </div>
                <h2 className="text-2xl font-black text-gray-900 mb-3" data-id="element-426">
                  Gen 2 WT Taekwondo Sensor Sock
                </h2>
                <p className="text-gray-600 mb-6" data-id="element-427">
                  The established standard for Gen 2 setups, still widely used
                  in many regional and national tournaments.
                </p>
                <div className="space-y-3" data-id="element-428">
                  <div className="flex items-start gap-3" data-id="element-429">
                    <ShieldCheckIcon className="w-5 h-5 text-gray-600 flex-shrink-0 mt-0.5" data-id="element-430" />
                    <span className="text-sm font-medium text-gray-800" data-id="element-431">
                      The standard for legacy Gen 2 setups
                    </span>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-432">
                    <InfoIcon className="w-5 h-5 text-gray-600 flex-shrink-0 mt-0.5" data-id="element-433" />
                    <span className="text-sm font-medium text-gray-800" data-id="element-434">
                      Still relevant where Gen 2 equipment is actively used
                    </span>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-gray-50 border-t border-gray-100 mt-auto" data-id="element-435">
                <a href="#daedo-pss-systems" className="block w-full text-center bg-gray-800 hover:bg-gray-900 text-white font-bold py-3 px-4 rounded-lg transition-colors" data-id="element-436">
                  Shop Gen 2 Footgear
                </a>
              </div>
            </div>
          </div>

          {/* Comparison Table */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden mb-16" data-id="element-437">
            <div className="p-6 bg-gray-900 text-white" data-id="element-438">
              <h3 className="text-xl font-bold uppercase tracking-wide" data-id="element-439">
                Generation Compatibility Overview
              </h3>
            </div>
            <div className="overflow-x-auto" data-id="element-440">
              <table className="w-full text-left border-collapse" data-id="element-441">
                <thead data-id="element-442">
                  <tr className="bg-gray-50 border-b border-gray-200" data-id="element-443">
                    <th className="p-4 font-bold text-gray-900 w-1/3" data-id="element-444">
                      Product
                    </th>
                    <th className="p-4 font-bold text-gray-900 w-1/6" data-id="element-445">
                      Generation
                    </th>
                    <th className="p-4 font-bold text-gray-900 w-1/4" data-id="element-446">
                      Best Use
                    </th>
                    <th className="p-4 font-bold text-gray-900" data-id="element-447">
                      Compatibility Notes
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200" data-id="element-448">
                  <tr className="hover:bg-blue-50/50 transition-colors" data-id="element-449">
                    <td className="p-4 font-bold text-blue-700" data-id="element-450">
                      Gen 3 WT Sensor Sock
                    </td>
                    <td className="p-4" data-id="element-451">
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-452">
                        Gen 3
                      </span>
                    </td>
                    <td className="p-4 text-gray-700" data-id="element-453">Current Gen 3 setups</td>
                    <td className="p-4 text-sm text-gray-600" data-id="element-454">
                      <strong className="text-gray-900" data-id="element-455">
                        Requires Gen 3 E-Hogu.
                      </strong>{' '}
                      The newest generation designed specifically for the Gen 3
                      scoring ecosystem.
                    </td>
                  </tr>
                  <tr className="hover:bg-gray-50 transition-colors" data-id="element-456">
                    <td className="p-4 font-bold text-gray-900" data-id="element-457">
                      Gen 2 WT Sensor Sock
                    </td>
                    <td className="p-4" data-id="element-458">
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-459">
                        Gen 2
                      </span>
                    </td>
                    <td className="p-4 text-gray-700" data-id="element-460">Legacy Gen 2 setups</td>
                    <td className="p-4 text-sm text-gray-600" data-id="element-461">
                      Older generation still relevant and required for events
                      utilizing Gen 2 equipment.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Usage Guidance */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 md:p-12 mb-16" data-id="element-462">
            <div className="flex items-center gap-3 mb-8 pb-6 border-b border-gray-100" data-id="element-463">
              <ZapIcon className="w-8 h-8 text-blue-600" data-id="element-464" />
              <h2 className="text-2xl font-black text-gray-900 uppercase tracking-tight" data-id="element-465">
                Why Generation Matching Matters
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-466">
              <div data-id="element-467">
                <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-468">
                  The Evolution to Gen 3
                </h3>
                <p className="text-gray-600 leading-relaxed mb-6" data-id="element-469">
                  Daedo's Gen 3 system represents a significant leap forward in
                  electronic scoring technology. The Gen 3 footgear features
                  updated sensor placements and materials designed to work
                  exclusively with the new Gen 3 Electronic Protectors (E-Hogu)
                  to ensure the most accurate and fair scoring possible.
                </p>

                <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-470">
                  Strict Compatibility
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-471">
                  Because the sensor technology has fundamentally changed,{' '}
                  <strong className="text-gray-900" data-id="element-472">
                    you cannot mix generations
                  </strong>
                  . Gen 3 footgear must be used with Gen 3 body protectors.
                  Attempting to use mismatched gear will result in inaccurate
                  scoring or complete failure to register hits.
                </p>
              </div>

              <div data-id="element-473">
                <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-474">
                  Forget the Old Charts
                </h3>
                <p className="text-gray-600 leading-relaxed mb-6" data-id="element-475">
                  If you've been in Taekwondo for a while, you may remember
                  complex charts comparing E-Foot G4, E-Heel, and E-Foot
                  Complete.{' '}
                  <strong className="text-gray-900" data-id="element-476">
                    Those charts are now obsolete.
                  </strong>{' '}
                  Today, the only question that matters is:{' '}
                  <em className="text-gray-800" data-id="element-477">
                    Is your tournament using Gen 2 or Gen 3?
                  </em>
                </p>

                <div className="bg-blue-50 rounded-xl p-5 border border-blue-100" data-id="element-478">
                  <h4 className="font-bold text-blue-900 mb-2 flex items-center gap-2" data-id="element-479">
                    <InfoIcon className="w-4 h-4" data-id="element-480" />
                    Before You Buy
                  </h4>
                  <p className="text-sm text-blue-800 leading-relaxed" data-id="element-481">
                    Always confirm with your tournament director or coach which
                    generation of Daedo PSS will be used at your upcoming
                    events. Buying the wrong generation will prevent you from
                    competing.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Legacy Models Accordion */}
          <div className="border border-gray-200 rounded-xl overflow-hidden bg-white" data-id="element-482">
            <button onClick={() => setShowLegacy(!showLegacy)} className="w-full flex items-center justify-between p-6 bg-gray-50 hover:bg-gray-100 transition-colors text-left" data-id="element-483">
              <div className="flex items-center gap-3" data-id="element-484">
                <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-500" data-id="element-485">
                  <InfoIcon className="w-4 h-4" data-id="element-486" />
                </div>
                <div data-id="element-487">
                  <h3 className="font-bold text-gray-700" data-id="element-488">
                    Archived Legacy Models
                  </h3>
                  <p className="text-sm text-gray-500 font-normal" data-id="element-489">
                    Information on discontinued Gen 1 / early Gen 2 variations
                  </p>
                </div>
              </div>
              <ChevronDownIcon className={`w-5 h-5 text-gray-400 transition-transform duration-300 ${showLegacy ? 'rotate-180' : ''}`} data-id="element-490" />
            </button>

            {showLegacy && <div className="p-6 border-t border-gray-200 text-sm text-gray-600 leading-relaxed bg-white" data-id="element-491">
                <p className="mb-4" data-id="element-492">
                  Historically, Daedo produced several variations of footgear
                  primarily for the Gen 1 system, which are now largely obsolete
                  in modern competition:
                </p>
                <ul className="space-y-3 list-disc pl-5 mb-4" data-id="element-493">
                  <li data-id="element-494">
                    <strong className="text-gray-800" data-id="element-495">E-Foot G4 (Grey):</strong>{' '}
                    The standard 6-sensor sock used primarily with Gen 1 Hogus.
                  </li>
                  <li data-id="element-496">
                    <strong className="text-gray-800" data-id="element-497">E-Heel:</strong> A
                    single-sensor detachable heel piece used when E-Headgear was
                    implemented in higher-ranking divisions.
                  </li>
                  <li data-id="element-498">
                    <strong className="text-gray-800" data-id="element-499">E-Foot Complete:</strong>{' '}
                    A rare 7-sensor all-in-one piece that combined the standard
                    footgear with the heel sensor.
                  </li>
                </ul>
                <p className="text-gray-500 italic" data-id="element-500">
                  Note: The Gen 2 PSS (introduced for the 2016 Rio Olympics)
                  standardized the 11-sensor Gen 2 E-Footgear, replacing the
                  need for these fragmented variations in elite competition.
                </p>
              </div>}
          </div>
        </div>
      </main>

      <Footer data-id="element-501" />
    </div>;
}